define("tmds/symbols/SimplePointSymbol", [
	"jquery",
	"./SimpleLineSymbol",
	"./Symbol",
	"./utils",
	"../validator"
], function($, SimpleLineSymbol, Symbol, utils, validator) {
	"use strict";
	
	var constants = {
		STYLE_CIRCLE: "circle",
		STYLE_CROSS: "cross",
		STYLE_DIAMOND: "diamond",
		STYLE_PATH: "path",
		STYLE_SQUARE: "square",
		STYLE_TRIANGLE_DOWN: "triangle-down",
		STYLE_TRIANGLE_UP: "triangle-up"
	};
	
	/**
	 * construct a new SimplePointSymbol
	 * @param options {Object} option object with below structure
	 * 		{
	 * 			style: 'square',
	 * 			color: [255,0,0,0.5],
	 * 			size: 12,
	 * 			angle: 180,
	 * 			xOffset: 2,
	 * 			yOffset: -5,
	 * 			outline: {
	 * 				type: "SimpleLineSymbol",
	 * 				color: [0,0,0,1],
	 * 				width: 1,
	 * 				style: 'solid'
	 * 			}
	 * 		}
	 * @note all option members are optional
	 */
	var SimplePointSymbol = function(options) {
		
		Symbol.call(this, options);
		
		/**
		 * default point symbol: solid black round point
		 */
		this.style = 'circle';
		this.color = [0,0,0,1];
		this.size = 10;
		this.angle = 0;
		this.xOffset = 0;
		this.yOffset = 0;
		//this.outline = null;
		
		if (options != undefined) {
			if (validator.isDataObject(options)) {
				
				if(options.style != undefined) 
					setStyle.call(this, options.style);
					
				if(options.path != undefined && options.style == 'path') 
					setPath.call(this, options.path);
				
				if(options.color != undefined) 
					setColor.call(this, options.color);
				
				if(options.size != undefined) 
					setSize.call(this, options.size);
				
				if(options.angle != undefined) 
					setAngle.call(this, options.angle);
				
				if(options.xOffset != undefined || options.yOffset != undefined)
					setOffset.call(this, options.xOffset, options.yOffset);
				
				if(options.outline != undefined) 
					setOutline.call(this, new SimpleLineSymbol(options.outline));
			}
			else {
			 	throw new Error('Invalid options values - ' + options + ' passed');
		 	}
		}
	};
	
	/**
	 * set the point symbol color
	 * @param color {Array} [r,g,b,a]
	 * @return the symbol itself
	 */
	function setColor(color) {
		
		var _color = utils.toColorArray(color);

		if(_color === false) {
			
			throw new Error('Invalid color value - ' + color + ' passed');
		}
		
		this.color = _color;
		return this;
	}
	
	/**
	 * set the point symbol angle
	 * @param angle {Number} new angle value
	 * @return the symbol itself
	 */
	function setAngle(angle) {
		
		if(! validator.isValidAngle(angle)) {
			
			throw new Error('Invalid angle value - ' + angle + ' passed');
		}
		
		this.angle = Number(angle);
		return this;
	}
	
	/**
	 * set the symbol offset
	 * @param x {Number} new x offset value
	 * @param y {Number} new y offset value
	 * @return the symbol itself
	 */
	function setOffset(x, y) {
		
		var validX = validator.isNumber(x),
			validY = validator.isNumber(y);
		
		if((x != undefined && ! validX) || (y != undefined && ! validY) || (x == undefined && y == undefined)) {
			
			throw new Error('Invalid xOffset, yOffset values - ' + x  + ' , ' + y + ' passed');
		}
		
		if(validX) this.xOffset = Number(x);
		
		if(validY) this.yOffset = Number(y);
		
		return this;
	}
	
	/**
	 * set the point symbol outline
	 * @param outline {tmds.symbols.SimpleLineSymbol} new outline symbol
	 * @return the symbol itself
	 */
	function setOutline(outline) {
		
		if(! validator.isDataObject(outline) || ! validator.isInstanceOf(outline, SimpleLineSymbol)) {
			
			throw new Error('Invalid outline instance - ' + outline + ' passed');
		}
		
		this.outline = outline;
		
		return this;
	}
	
	/**
	 * set the point shape to the given path string and switches the style to 'path'
	 * @param path {String} SVG path of the icon symbol
	 * @return the symbol itself
	 */
	function setPath(path) {
		
		if(! validator.isValidSvgPath(path)) {
			
			throw new Error('Invalid path string - ' + path + ' passed');
		}
		
		this.path = path;
		this.style = 'path';
		return this;
	}
	
	/**
	 * set the point symbol size
	 * @param size {Number} new point symbol size
	 * @return the symbol itself
	 */
	function setSize(size) {
		
		if(! validator.isValidMin(size, 1)) {
			
			throw new Error('Invalid size value - ' + size + ' passed');
		}
		
		this.size = Number(size);
		return this;
	}
	
	/**
	 * set the point symbol style
	 * @param style {String}
	 * @return the symbol itself
	 */
	function setStyle(style) {
		
		if(! validator.isValidPointStyle(style)) {
			
			throw new Error('Invalid point style value - ' + style + ' passed');
		}
		
		this.style = style;
		return this;
	}
	
	/**
	 * convert SimplePointSymbol object to JSON representation
	 */
	function toJson() {
		
		var obj = {
			type: this.type,
			style: this.style,
			color: this.color,
			size: this.size,
			angle: this.angle,
			xOffset: this.xOffset,
			yOffset: this.yOffset
		};
		
		if(validator.isDataObject(this.outline))
			obj.outline = this.outline.toJson();
			
		if(this.path != undefined)
			obj.path = this.path;
			
		return obj;
	}
	
	/**
	 * define static methods
	 */
	SimplePointSymbol.styles = function() { return constants; };
	
	// SimplePointSymbol inherits Symbol with some extensions
	SimplePointSymbol.prototype = $.extend(Object.create(Symbol.prototype), {		
		declaredClass: "tmds.symbols.SimplePointSymbol",
		type: "SimplePointSymbol",
		'setColor' : setColor,
		'setAngle' : setAngle,
		'setOffset' : setOffset,
		'setOutline' : setOutline,
		'setPath' : setPath,
		'setSize' : setSize,
		'setStyle' : setStyle,
		'toJson' : toJson
	});
	
	return SimplePointSymbol;
});